import React, { useState, useEffect } from 'react';
import '../../styles/AdminModal.css';
import { addBoat } from '../../services/AdminBoatService';
import { validateBoat } from '../../validations/admin/AdminBoatValidation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import BoatForm from '../../forms/boats/BoatForm';
import BoatGalleryImages from './BoatGalleryImages';

const BoatAddModal = ({ isOpen, onClose, onSuccess, categories }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    main_image: null,
    gallery_images: [],
    length: '',
    capacity: '',
    staterooms: '',
    bathrooms: '',
    featured: false,
    category: null,
    price: '',
    discount_price: '',
    note: '',
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setFormData({
        name: '',
        description: '',
        main_image: null,
        gallery_images: [],
        length: '',
        capacity: '',
        staterooms: '',
        bathrooms: '',
        featured: false,
        category: null,
        price: '',
        discount_price: '',
        note: '',
      });
      setErrors({});
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === 'category_id') {
      const selectedCategory = categories.find(cat => cat.id === parseInt(value));
      setFormData(prevFormData => ({
        ...prevFormData,
        category: selectedCategory
      }));
    } else if (name === 'main_image') {
      const file = e.target.files[0];
      setFormData((prevFormData) => ({
        ...prevFormData,
        main_image: file,
      }));
    } else {
      let fieldValue = value;
      if ([
        'length', 'capacity', 'staterooms', 'bathrooms'
      ].includes(name)) {
        fieldValue = value.replace(/[^0-9]/g, '');
      }
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: type === 'checkbox' ? checked : fieldValue,
      }));
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData((prevFormData) => ({
      ...prevFormData,
      main_image: file,
    }));
  };

  const handleSave = async () => {
    const validationErrors = validateBoat(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setLoading(true);
    setErrors({});
    try {
      console.log('DEBUG gallery_images:', formData.gallery_images);
      formData.gallery_images.forEach((img, idx) => {
        console.log(`DEBUG gallery_images[${idx}]:`, img, 'type:', typeof img, 'instanceof File:', img instanceof File);
      });
      const formDataToSend = new FormData();
      formDataToSend.append('name', formData.name);
      formDataToSend.append('description', formData.description);
      formDataToSend.append('length', formData.length);
      formDataToSend.append('capacity', formData.capacity);
      formDataToSend.append('staterooms', formData.staterooms);
      formDataToSend.append('bathrooms', formData.bathrooms);
      formDataToSend.append('featured', formData.featured);
      formDataToSend.append('price', formData.price || '');
      formDataToSend.append('discount_price', formData.discount_price || '');
      formDataToSend.append('note', formData.note || '');
      if (formData.category && formData.category.id) {
        formDataToSend.append('category', formData.category.id);
      }
      if (formData.main_image && formData.main_image instanceof File) {
        formDataToSend.append('main_image', formData.main_image);
      }
      formData.gallery_images.forEach((image) => {
        formDataToSend.append('gallery_images', image);
      });
      for (let pair of formDataToSend.entries()) {
        console.log('DEBUG FormData entry:', pair[0], pair[1]);
      }
      await addBoat(formDataToSend);
      await onSuccess();
      setFormData({
        name: '',
        description: '',
        main_image: null,
        gallery_images: [],
        length: '',
        capacity: '',
        staterooms: '',
        bathrooms: '',
        featured: false,
        category: null,
        price: '',
        discount_price: '',
        note: '',
      });
      onClose();
    } catch (error) {
      console.error('Error completo:', error);
      setErrors({ submit: 'Error adding boat. Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  const sizeError = Object.keys(errors).some((key) => errors[key].includes("must be less than 2MB"));
  const galleryErrorIndexes = Object.keys(errors)
    .filter((key) => key.startsWith('gallery_images_'))
    .map((key) => parseInt(key.split('_')[2], 10));

  return (
    <div className="admin__modal">
      <div className="admin__modal-content">
        <div className="admin__modal-intro">
          <h2>Add New Boat</h2>
          <button className="admin__modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faClose} />
          </button>
        </div>
        {errors.submit && <div className="error-message">{errors.submit}</div>}
        <div className="admin__modal-body">
          <BoatForm
            formData={formData}
            errors={errors}
            categories={categories}
            handleChange={handleChange}
            handleFileChange={handleFileChange}
          />
        </div>
        <div className="admin__modal-gallery">
          <BoatGalleryImages
            galleryImages={formData.gallery_images}
            onChange={(updatedImages) =>
              setFormData((prev) => ({ ...prev, gallery_images: updatedImages }))
            }
            errorIndexes={galleryErrorIndexes}
          />
          {sizeError && (
            <div className="error-message">
              Image size must not exceed 2MB.
            </div>
          )}
        </div>
        <div className="admin__modal-buttons">
          <button className="button secondary" onClick={onClose} disabled={loading}>
            {loading ? 'Saving...' : 'Cancel'}
          </button>
          <button className="button" onClick={handleSave} disabled={loading}>
            {loading ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BoatAddModal;